define.alias("ember-cli-clipboard/helpers/is-clipboard-supported", "settings/helpers/is-clipboard-supported");